/**
 * `Blob.text()` would be the obvious way to do this, but jsdom does not implement it, so anything
 * built on it would only ever be exercised in a browser.
 */
export const readFileAsText = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    // `readAsText` always produces a string; the union only exists for the binary readers.
    reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : '');
    reader.onerror = () => reject(reader.error);
    reader.readAsText(file);
  });
